var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-start"},[_c('div',{staticClass:"receiverBody d-flex flex-column w-75 m-3 p-2 rounded"},[_c('p',[_vm._v("Automated Bot")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v("The time to response to your message may be delayed, please be patient and thank you")]),_c('p',[_vm._v(_vm._s(_vm.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }